module.exports = __webpack_public_path__ + "images/emoji/tropical_fish.c6a928ba8df8452dac20.png";